import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aurelo_token");
  const tenant = localStorage.getItem("aurelo_tenant");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (tenant) config.headers["X-Tenant-Id"] = tenant;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("aurelo_token");
      localStorage.removeItem("aurelo_tenant");
      if (!window.location.pathname.match(/^\/(login|signup|)$/)) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
